import { NavLink } from "react-router-dom";
import { Home, Flag, Search, Users, User } from "lucide-react";
import { useT } from "../i18n";
import { useNotifications } from "../context/NotificationsContext";

const Badge = ({ count, className = "" }) => (count > 0 ? <span data-testid="notifications-badge" className={`absolute flex h-4 min-w-[16px] items-center justify-center rounded-full bg-rox-orange px-1 text-[10px] font-bold leading-none text-rox-black ${className}`}>{count > 9 ? "9+" : count}</span> : null);

export const NAV_ITEMS = [
  { to: "/", key: "nav_home", icon: Home, id: "home" },
  { to: "/courses", key: "nav_races", icon: Flag, id: "races" },
  { to: "/recherche", key: "nav_search", icon: Search, id: "search" },
  { to: "/matchs", key: "nav_matches", icon: Users, id: "matches" },
  { to: "/profil", key: "nav_profile", icon: User, id: "profile" },
];

export const BottomNav = () => {
  const { t } = useT();
  const { unread } = useNotifications();
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed inset-x-0 bottom-0 z-30 mx-auto w-full max-w-md border-t border-rox-line bg-rox-black/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md print:hidden lg:hidden"
    >
      <div className="grid grid-cols-5">
        {NAV_ITEMS.map(({ to, key, icon: Icon, id }) => (
          <NavLink
            key={id}
            to={to}
            end={to === "/"}
            data-testid={`nav-${id}`}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-3 text-[10px] font-semibold uppercase tracking-wider transition-colors ${
                isActive ? "text-rox-orange" : "text-rox-muted hover:text-rox-off"
              }`
            }
          >
            <span className="relative"><Icon size={20} strokeWidth={2.2} />{id === "search" && <Badge count={unread} className="-right-2.5 -top-1.5" />}</span>
            {t(key)}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export const DesktopNav = () => {
  const { t } = useT();
  const { unread } = useNotifications();
  return (
    <nav className="hidden items-center gap-1 lg:flex" data-testid="desktop-nav">
      {NAV_ITEMS.map(({ to, key, id }) => (
        <NavLink key={id} to={to} end={to === "/"} data-testid={`desktop-nav-${id}`}
          className={({ isActive }) => `relative rounded-[3px] px-3 py-2 font-display text-sm uppercase tracking-wider transition-colors ${isActive ? "text-rox-orange" : "text-rox-off/80 hover:text-rox-off"}`}>
          {t(key)}{id === "search" && <Badge count={unread} className="-right-1 top-0" />}
        </NavLink>
      ))}
    </nav>
  );
};
